var _polygon, _polygon2, _polygon3, _polygon4, _circle, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _circle2, _polygon12, _polygon13, _polygon14, _circle3, _circle4, _circle5, _polygon15, _polygon16, _polygon17, _polygon18, _circle6, _circle7, _circle8, _polygon19, _polygon20, _polygon21, _polygon22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFelineDental(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dental",
    viewBox: "0 0 778 1368",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: 101,
    points: "386, 83, 394, 63, 389, 51, 375, 55, 372, 65, 377, 78",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: 102,
    points: "359, 87, 369, 86, 369, 64, 366, 54, 359, 50, 349, 53, 350, 71",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: 103,
    points: "349, 95, 345, 62, 336, 59, 327, 67, 324, 79, 325, 92, 333, 99",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: 104,
    points: "236, 58, 233, 155, 238, 185, 273, 194, 292, 164, 293, 145, 276, 89, 252, 50",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: 105,
    cx: 229,
    cy: 243,
    r: 21,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: 106,
    points: "172, 374, 192, 321, 209, 302, 231, 304, 238, 316, 212, 369, 193, 380, 179, 382",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: 107,
    points: "96, 495, 153, 389, 172, 381, 196, 394, 219, 420, 211, 438, 170, 449, 154, 479, 122, 511, 95, 516",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: 108,
    points: "98, 525, 120, 514, 142, 514, 161, 524, 160, 540, 144, 546, 108, 535",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: 201,
    points: "402, 55, 402, 70, 407, 80, 416, 81, 420, 63, 414, 51",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: 202,
    points: "425, 67, 435, 52, 445, 53, 445, 63, 435, 85, 423, 83",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: 203,
    points: "448, 64, 467, 65, 463, 97, 444, 98, 442, 77",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: 204,
    points: "501, 161, 511, 106, 526, 85, 538, 52, 551, 52, 553, 96, 556, 119, 559, 154, 556, 179, 536, 196, 510, 188, 501, 175",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: 205,
    cx: 558,
    cy: 242,
    r: 21,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    id: 206,
    points: "558, 336, 548, 315, 560, 303, 582, 308, 612, 367, 611, 383, 586, 386, 568, 367",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    id: 207,
    points: "608, 455, 566, 431, 565, 418, 610, 386, 625, 384, 638, 404, 668, 473, 678, 501, 682, 518, 670, 525, 655, 516, 629, 489",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    id: 208,
    points: "618, 524, 652, 516, 673, 530, 667, 543, 623, 551, 616, 539",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: 301,
    cx: 395,
    cy: 1303,
    r: 11,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: 302,
    cx: 419,
    cy: 1302,
    r: 10,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: 303,
    cx: 441,
    cy: 1298,
    r: 11,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    id: 304,
    points: "437, 1256, 449, 1284, 485, 1299, 536, 1295, 543, 1288, 497, 1252, 476, 1213, 466, 1212, 450, 1220, 439, 1235",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    id: 305,
    points: "502, 1088, 522, 1052, 535, 1044, 544, 1065, 524, 1105, 509, 1112, 500, 1101",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    id: 306,
    points: "533, 1034, 531, 1017, 543, 982, 556, 970, 570, 972, 572, 991, 568, 1017, 561, 1030, 547, 1043",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    id: 307,
    points: "549, 941, 559, 927, 569, 885, 599, 859, 612, 860, 619, 873, 607, 923, 577, 968, 559, 965, 549, 954",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: 401,
    cx: 370,
    cy: 1303,
    r: 11,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: 402,
    cx: 346,
    cy: 1302,
    r: 10,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: 403,
    cx: 321,
    cy: 1298,
    r: 11,
    stroke: "black",
    strokeWidth: 4,
    fill: "white"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    id: 404,
    points: "219, 1284, 267, 1256, 280, 1228, 291, 1212, 309, 1209, 328, 1249, 312, 1283, 286, 1295, 249, 1296, 223, 1293",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    id: 405,
    points: "242, 1109, 218, 1050, 227, 1042, 241, 1044, 265, 1091, 264, 1104",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    id: 406,
    points: "194, 1013, 190, 972, 203, 967, 215, 971, 232, 1007, 230, 1025, 217, 1037, 200, 1029",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    id: 407,
    points: "161, 927, 143, 893, 144, 863, 152, 855, 172, 859, 189, 870, 205, 924, 216, 940, 203, 965, 171, 952",
    fill: "white",
    strokeWidth: 4,
    stroke: "black"
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFelineDental);
export default __webpack_public_path__ + "static/media/FelineDental.7cd458675b0c8242cf01e549007898c0.svg";
export { ForwardRef as ReactComponent };